export default class Store {
  static data = {};

  static bus = document.createElement('div');
}
